<ng-container *ngIf="{ students: students$ | async, loading: loading$ | async, targets: targets$ | async } as data">
  <div class="rounded-t-xl border-x border-t border-base-gray-100">
    <div class="flex flex-col items-center justify-between gap-2 p-4 xl:flex-row">
      <div class="w-full xl:w-2/4">
        <div class="relative flex items-center">
          <input
            app-input
            [formControl]="searchCtrl"
            class="w-full rounded-full! shadow-inner placeholder:text-base placeholder:font-normal"
            [placeholder]="'eclass.digite-buscar' | translate"
          />
          <svg-icon class="absolute right-3 h-4 w-4 text-base-gray-200" src="assets/icons/icon-search.svg"></svg-icon>
        </div>
      </div>
      <div class="flex w-full flex-row items-center justify-end gap-2">
        <input
          app-checkbox
          class="text-theme-500"
          type="checkbox"
          [checked]="isAllchecked(data.students)"
          [indeterminate]="isIndeterminateStatus(data.students)"
          (click)="onSelectAll($event.target.checked, data.students)"
        />
        <label translate app-label class="!p-0 !text-base">eclass.marcar-tudo</label>
      </div>
    </div>
  </div>
  <div
    class="h-80 overflow-y-auto rounded-b-xl border-x border-b border-base-gray-100 bg-base-gray-light-200 p-4 shadow-inner-bg"
  >
    <ng-container *ngIf="!data.loading; else loadTemplate">
      <ng-container *ngIf="!(data.targets | isEmpty); else emptyTargetTemplate">
        <ng-container *ngIf="data.students | filter: searchCtrl.value : ['name'] as students">
          <ng-container *ngIf="!(students | isEmpty); else emptyTemplate">
            <div class="grid grid-cols-1 gap-2 xl:grid-cols-2">
              <div
                app-button
                *ngFor="let student of students; trackBy: trackById"
                (click)="onSelect(student)"
                class="flex w-full justify-start! gap-4 rounded-md bg-white p-1 transition duration-300"
                [ngClass]="{
                  '!bg-theme-400 !text-white shadow-inner shadow-black/25': isSelected(student.id),
                  'shadow-md': !isSelected(student.id),
                }"
              >
                <span class="border-1 flex w-max !rounded-full bg-white/80 !p-1 shadow-sm shadow-black/40">
                  <app-user-photo class="h-10 w-10" [src]="student.photo"></app-user-photo>
                </span>
                <div class="flex w-full items-center justify-between truncate">
                  <div class="grid">
                    <div class="flex w-full items-center justify-between gap-2">
                      <p class="mb-1 text-base">
                        {{ student.name }}
                      </p>
                    </div>

                    <div
                      class="flex w-full items-center gap-2 truncate text-sm text-gray-600"
                      [ngClass]="{ '!text-white': isSelected(student.id) }"
                    >
                      {{ student.target?.grade.description }}
                      <svg-icon
                        src="assets/icons/icon-ellipse.svg"
                        class="flex h-2 w-2 text-gray-700"
                        [ngClass]="{ '!text-white': isSelected(student.id) }"
                      ></svg-icon>
                      {{ student.target?.group.description }}
                    </div>
                  </div>
                  <div class="flex items-center">
                    <svg-icon
                      *ngIf="!!student.pcd"
                      app-tooltip
                      [tooltip]="'eclass.aluno-laudado' | translate"
                      class="h-6 w-6 text-gray-400"
                      src="assets/icons/icon-info-rounded.svg"
                    ></svg-icon>
                  </div>
                  <div
                    *ngIf="student.showEntity"
                    class="w-full truncate text-sm text-theme-700"
                    [ngClass]="{ '!text-white': isSelected(student.id) }"
                  >
                    {{ student.target?.entity.description }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #loadTemplate>
      <app-skeleton></app-skeleton>
    </ng-template>
    <ng-template #emptyTemplate>
      <app-jumbotron translate> geral.filtro-vazio </app-jumbotron>
    </ng-template>
    <ng-template #emptyTargetTemplate>
      <app-jumbotron translate> eclass.selecione-disciplina-turma </app-jumbotron>
    </ng-template>
  </div>
</ng-container>
